import * as React from 'react';

import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
    DialogTrigger,
} from 'src/registry/ui/Dialog';
import { Image } from 'src/registry/ui/Image';
import { cn } from 'src/utils/shadcn';

interface ImageModalProps extends React.HTMLAttributes<HTMLDivElement> {
    image?: string;
    alt?: string;
    title?: string;
    disableClick?: boolean;
}

const ImageModal = ({ image, alt, title, disableClick = false }: ImageModalProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [imageErrors, setImageErrors] = React.useState<Record<string, boolean>>({});

    const handleImageError = (error: Record<string, boolean>) => {
        setImageErrors((prev) => ({ ...prev, ...error }));
    };
    const disableOpenModal = !!(disableClick || (image && imageErrors[image]));

    return (
        <Dialog
            open={isModalOpen}
            onOpenChange={(open) => {
                if (disableOpenModal) return;
                setIsModalOpen(open);
            }}
        >
            <div className={cn('rounded-lg border p-1', !disableOpenModal && 'cursor-pointer')}>
                <DialogTrigger asChild>
                    <Image image={image} alt={alt} onErrorCallback={handleImageError} />
                </DialogTrigger>
            </div>
            <DialogContent
                onOpenAutoFocus={(e) => {
                    e.preventDefault();
                }}
                className="flex size-[90%] max-h-[90%] max-w-[90%] flex-col overflow-hidden p-0"
            >
                <DialogHeader className="flex-none">
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                <DialogSeparator />

                <DialogBody className="flex min-h-0 flex-1 items-center justify-center p-2 sm:p-4 md:p-6">
                    <div className="flex max-h-[60vh] max-w-[70vw] items-center justify-center [&>img]:size-auto [&>img]:max-h-full [&>img]:max-w-full [&>img]:object-contain">
                        <Image image={image} alt={alt} />
                    </div>
                </DialogBody>
            </DialogContent>
        </Dialog>
    );
};

export default ImageModal;
